import { connect } from 'react-redux';

import { StoreState } from '../../../../../../reducers';
import Item from '../../../../../../components/Editor/CombinePanel/SpreadsSelector/Grid/Item';
import { ThumbnailData } from '../../../../../../components/Editor/Thumbnails/constants';
import { getPageHtmlPath } from '../../../../utils/helpers';
import UrlUtils from '../../../../../../utils/url';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		galleryInfos: { config: galleryConfig },
		editor: {
			combo: {
				externalPublication: {
					globalId,
					selection: { spreadIndices: selectedSpreadIndices },
					thumbnails,
					thumbnailPath,
					spreadPath,
					configs: {
						generalData: { editablePublication: editableData },
					},
					itemsInRow,
				},
			},
			version,
		},
	} = state;
	const { spread, spreadIndex } = ownProps;

	let thumbnailsData: ThumbnailData[] = [];

	if (spreadPath) {
		thumbnailsData.push({
			...thumbnails[spread[0] - 1],
			imageSrc: UrlUtils.getEditorResourceUrl(galleryConfig, globalId as number, `${getPageHtmlPath(spreadPath, spreadIndex + 1)}?version=${version}`),
		});
	} else {
		thumbnailsData = spread.map((page) => {
			const { position } = thumbnails[page - 1];

			return {
				...thumbnails[page - 1],
				imageSrc: UrlUtils.getEditorResourceUrl(galleryConfig, globalId as number, `${getPageHtmlPath(thumbnailPath, position)}?version=${version}`),
			};
		});
	}

	return {
		thumbnailsData,
		isActive: selectedSpreadIndices.includes(spreadIndex),
		isEditable: spread.some(page => Object.keys(editableData).includes(page.toString())),
		itemsInRow,
	};
};

export default connect(mapStateToProps)(Item);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/CombinePanel/SpreadsSelector/Grid/Item/index.tsx